import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import React, { useEffect } from 'react';
import BugReporter, { bugReporterModalKey } from '../../tools/bugReporter/BugReporter';
import EasterEgg from '../../tools/easterEgg/EasterEgg';
import useModalStore from '../../ui/uiElements/advanced/modal/dataLayer/hooks/UseModalStore';
import ConsoleHistory from '../ConsoleHistory';
import ApplicationInsights from '../providers/ApplicationInsights';
var InsightsContextProvider = function (_a) {
    var children = _a.children, instrumentationKey = _a.instrumentationKey;
    var modalStore = useModalStore();
    useEffect(function () {
        ConsoleHistory.initialize();
        ApplicationInsights.initialize(instrumentationKey);
        EasterEgg.register('bug!', function () {
            modalStore.openModal(bugReporterModalKey);
        });
    }, []);
    return (React.createElement(AppInsightsContext.Provider, { value: ApplicationInsights.reactPlugin },
        children,
        React.createElement(BugReporter, null)));
};
export default InsightsContextProvider;
//# sourceMappingURL=InsightsContextProvider.js.map